import { useCallback, useEffect, useState } from "react";
import { EmblaCarouselType } from "embla-carousel";
import { cn } from "@/lib/utils";

interface CarouselDotsProps {
  emblaApi: EmblaCarouselType | undefined;
  className?: string;
}

export const CarouselDots = ({ emblaApi, className }: CarouselDotsProps) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState<number[]>([]);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  const scrollTo = useCallback(
    (index: number) => {
      if (emblaApi) emblaApi.scrollTo(index);
    },
    [emblaApi]
  );

  useEffect(() => {
    if (!emblaApi) return;
    setScrollSnaps(emblaApi.scrollSnapList());
    emblaApi.on("select", onSelect);
    onSelect();
    
    return () => {
      emblaApi.off("select", onSelect);
    };
  }, [emblaApi, onSelect]);

  if (scrollSnaps.length <= 1) return null;

  return (
    <div className={cn("flex items-center justify-center gap-1 mt-6", className)}>
      {scrollSnaps.map((_, index) => (
        <button
          key={index}
          onClick={() => scrollTo(index)}
          aria-label={`Vai alla slide ${index + 1}`}
          className={cn(
            "h-2 w-6 border-2 border-dark transition-all duration-200",
            "hover:bg-primary/50",
            "focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2",
            index === selectedIndex
              ? "bg-primary shadow-[2px_2px_0px_#101322]"
              : "bg-transparent"
          )}
        />
      ))}
    </div>
  );
};
